import { Component, OnInit } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'well-ntp-logo',
  standalone: true,
  imports: [NgStyle],
  templateUrl: './ntp-logo.component.html',
  styleUrl: './ntp-logo.component.scss',
})
export class NtpLogoComponent implements OnInit {
  version: string | undefined;
  bgColor: string | undefined;
  logoColor: string | undefined;
  parentBgColor: string | undefined;
  parentDivBgColor: string | undefined;
  logoSrc: string | undefined;
  ngOnInit(): void {
    const script = document.querySelector('script[src^="https://mny.ro/npId.js"]') as HTMLElement;
    this.bgColor = script?.dataset?.['contrastColor'];
    this.version = script?.dataset?.['version'];

    const contrastRatio =
      this.differenceBetweenTwoColors(this.bgColor, "#EB001B") < 0.25 ||
      this.differenceBetweenTwoColors(this.bgColor, "#F79E1B") < 0.25;

    this.logoColor = "black";
    this.parentBgColor = "#ffffff80";

    this.parentDivBgColor = contrastRatio ? this.parentBgColor : "transparent";

    this.logoSrc = `https://mny.ro/np-${this.logoColor}-${this.version === 'vertical' ? 1 : 0}.svg`;
  }
  rgbColor(color: string | undefined): { rgb: number[], hsp: number } {
    let r = 0, g = 0, b = 0, hsp = 0;

    if (color?.match(/^rgb/)) {
      const matchResult = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?)?)\)$/);

      if (matchResult) {
        r = +matchResult[1];
        g = +matchResult[2];
        b = +matchResult[3];
      }

    } else {
      const hexColor = color ? parseInt(color.slice(1).replace(/./g, "$&$&"), 16) : 0;
      r = (hexColor >> 16) & 255;
      g = (hexColor >> 8) & 255;
      b = hexColor & 255;
    }

    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    return { rgb: [r, g, b], hsp: hsp };
  }

  differenceBetweenTwoColors(color1: string | undefined, color2: string | undefined): number {
    const [r1, g1, b1] = this.rgbColor(color1).rgb;
    const [r2, g2, b2] = this.rgbColor(color2).rgb;
    const d = Math.sqrt(Math.pow(r2 - r1, 2) + Math.pow(g2 - g1, 2) + Math.pow(b2 - b1, 2));
    return d / Math.sqrt(Math.pow(255, 2) + Math.pow(255, 2) + Math.pow(255, 2));
  }

  goToNetopiaPaymentsWebsite(): void {
    window.open("https://netopia-payments.com/", "_blank");
  }
}
